import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import analytics from '@services/analyticsService';

const PageTracker = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    analytics.page(location.pathname);
  }, [location.pathname]);

  return children;
};

export default PageTracker;
